import React from 'react'
import { Grid } from '@material-ui/core'
import OnboardingSectionTitle from '../../../_global/OnboardingSectionTitle'
import WorkPreferencesForm from './Form'
import { useOnboarding } from '../../../contexts/OnboardingContext'
import { useQuery } from '@apollo/react-hooks'
import WORK_PREFERENCES_QUERY from '../../../apolloClient/queries/getWorkPreferences'
import Error from '../../../_global/Error'
import Loader from '../../../_global/Loader'

const WorkPreferences = () => {
  const { currentExpert } = useOnboarding()

  const { loading, error, data } = useQuery(WORK_PREFERENCES_QUERY, {
    variables: { id: currentExpert.id },
    skip: !currentExpert.id,
  })

  if (loading) return <Loader />
  if (error) return <Error />

  const {
    getExpert: { id, legacyFreelancerId, paroIncomeStatus, hasCurrentClients, workPreference },
  } = data

  const initialValues = {
    ...(workPreference?.id && { id: workPreference?.id }),
    contactStylePreference: workPreference?.contactStylePreference || '',
    contactTimePreference: workPreference?.contactTimePreference || '',
    expertId: id || currentExpert.id,
    hasCurrentClients: typeof hasCurrentClients === 'boolean' ? hasCurrentClients : '',
    intendedMonthlyIncome: workPreference?.intendedMonthlyIncome || '',
    isOpenToOnsite: typeof workPreference?.isOpenToOnsite === 'boolean' ? workPreference?.isOpenToOnsite : '',
    legacyFreelancerId,
    paroIncomeStatus: paroIncomeStatus || '',
    projectType: workPreference?.projectType || '',
    totalFreelanceExperience: workPreference?.totalFreelanceExperience || '',
    weeklyWorkloadHours: workPreference?.weeklyWorkloadHours || '',
  }

  return (
    <Grid container item>
      <Grid item>
        <OnboardingSectionTitle
          title="Work Preferences"
          description="It’s time to let us know your availability and commitment goals. Getting you projects that you enjoy is beneficial for everyone. Let us know the types of projects you want and how you work."
        ></OnboardingSectionTitle>
      </Grid>
      <Grid item>
        <WorkPreferencesForm initialValues={initialValues} />
      </Grid>
    </Grid>
  )
}

export default WorkPreferences
